module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226160191_04_Pre#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226160191_05_Ch1#c001"
    }
  }, [_vm._v("1. Arms and Society in Antiquity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226160191_06_Ch2#c002"
    }
  }, [_vm._v("2. The Era of Chinese Predominance, 1000–1500")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226160191_06_Ch2#c002_sec1"
    }
  }, [_c('em', [_vm._v("Market and Command in Medieval China")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226160191_06_Ch2#c002_sec2"
    }
  }, [_c('em', [_vm._v("Market Mobilization beyond China’s Borders")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_07_Ch3#c003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Business of War in Europe, 1000–1600")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_07_Ch3#c003_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pioneering Business of War in Northern Italy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_07_Ch3#c003_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Gunpowder Revolution and the Rise of Atlantic Europe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_07_Ch3#c003_sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Market Asserts Control")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_08_Ch4#c004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Advances in Europe’s Art of War, 1600–1750")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_08_Ch4#c004_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Geographical Spread")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_08_Ch4#c004_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Improvements in the Control of Armies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_08_Ch4#c004_sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Standardization and Quasi-Stabilization of European Armed Forces")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_09_Ch5#c005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Strains on Europe’s Bureaucratization of Violence, 1700–1789")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_09_Ch5#c005_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Disequilibrium Arising from Frontier Expansion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_09_Ch5#c005_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Challenges Arising from Deliberate Reorganization")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_10_Ch6#c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Military Impact of the French Political and the British Industrial Revolutions, 1789–1840")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_10_Ch6#c006_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The French Formula for Relieving Population Pressure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_10_Ch6#c006_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The British Variant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_10_Ch6#c006_sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Postwar Settlement, 1815–40")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_11_Ch7#c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Initial Industrialization of War, 1840–84")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_11_Ch7#c007_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Commercial and National Armaments Rivalries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_11_Ch7#c007_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A New Paradigm: The Prussian Way of War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_11_Ch7#c007_sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Global Repercussions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_12_Ch8#c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Intensified Military-Industrial Interaction, 1884–1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_12_Ch8#c008_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Decay of Britain’s Strategic Position")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_12_Ch8#c008_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Emergence of the Military-Industrial Complex in Great Britain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_12_Ch8#c008_sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Naval Armament and the Politicization of Economics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_12_Ch8#c008_sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Limits of Rational Design and Management")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_12_Ch8#c008_sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("International Repercussions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_13_Ch9#c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. World Wars of the Twentieth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_13_Ch9#c009_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Balance of Power and Demography in World Wars I and II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_13_Ch9#c009_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Managerial Metamorphosis in World War I: First Phase, 1914–16")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_13_Ch9#c009_sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Managerial Metamorphosis in World War 1: Second Phase, 1916–18")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_13_Ch9#c009_sec4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Interwar Reaction and Return to Managed Economies during World War II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_14_Ch10#c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Arms Race and Command Economies since 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_15_conclu#conclu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_16_Notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226160191_17_Ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b9fec6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226160191_03_Toc.vue
// module id = 63
// module chunks = 0